/* Mirrors the left sidebar's empty Favorites hint (chrome/app-sidebar.module.css `.empty`), with a title line */
.empty {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 4px 0 0;
  padding: 10px;
  border: 1px dashed var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-fontSize-xs);
  line-height: 1.45;
}

/* Explicit sizes: panel content can restyle a bare <p> */
.title,
.body {
  margin: 0;
}

.body {
  font-size: var(--tuna-typography-fontSize-xs);
}

.title {
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-fontSize-sm);
  font-weight: 500;
}
